/**
 * @generated SignedSource<<6fa245d09ba497cea4529ea646a12d76>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SitemapValueType_sitemap$data = {
  readonly sitemapLinks: ReadonlyArray<{
    readonly headerText: string | null;
    readonly items: ReadonlyArray<{
      readonly items: ReadonlyArray<{
        readonly label: string | null;
        readonly linkUrl: string | null;
        readonly title: string | null;
      } | null> | null;
      readonly label: string | null;
      readonly linkUrl: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly linksType: string | null;
    readonly resultsHeader: string | null;
  } | null> | null;
  readonly " $fragmentType": "SitemapValueType_sitemap";
};
export type SitemapValueType_sitemap$key = {
  readonly " $data"?: SitemapValueType_sitemap$data;
  readonly " $fragmentSpreads": FragmentRefs<"SitemapValueType_sitemap">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkUrl",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SitemapValueType_sitemap",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SitemapLink",
      "kind": "LinkedField",
      "name": "sitemapLinks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linksType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resultsHeader",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "linkItems",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "l3LinkItems",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v1/*:: as any*/),
                (v0/*:: as any*/),
                (v2/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Sitemap",
  "abstractKey": null
};
})();

(node as any).hash = "0a76c36caac3c27653cf042faf8a2f78";

export default node;
